<template>
  <div class="empty-permissions-page">
    <img class="layout__q-logo" src="/images/logo-small.svg" />
    <div class="empty-permissions-page__wrapper">
      <!-- Content -->
      <div class="empty-permissions-page__wrapper__content">
        <!-- Logo -->
        <div class="empty-permissions-page__wrapper__content__logo">
          <img
            class="empty-permissions-page__wrapper__content__logo__img"
            :src="`/images/logo.svg`"
            alt="OWQLO"
          />
        </div>

        <!-- Title -->
        <app-i18n 
          class="empty-permissions-page__wrapper__content__title" 
          :code="titleI18n" 
        />

        <!-- Description -->
        <app-i18n 
          class="empty-permissions-page__wrapper__content__description" 
          :code="messageI18n" 
        />

        <div 
          class="empty-permissions-page__wrapper__content__download-buttons"
        >
            <app-download-app-button
              :textSupI18n="butttons.ios.textSupI18n"
              :textNameI18n="butttons.ios.textNameI18n"
              :icon="butttons.ios.icon"
              :url="butttons.ios.url"
            />
            <app-download-app-button
              :textSupI18n="butttons.android.textSupI18n"
              :textNameI18n="butttons.android.textNameI18n"
              :icon="butttons.android.icon"
              :url="butttons.android.url"
            />
        </div>

         <!-- Phone -->
        <div class="empty-permissions-page__wrapper__content__phone">
          <img class="empty-permissions-page__wrapper__content__phone__img" src="/images/iphone.png" />
        </div>
      </div>
      <!-- Phone -->
      <!-- <div class="empty-permissions-page__wrapper__phone">
        <img class="empty-permissions-page__wrapper__phone__img" src="/images/iphone.png" />
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'app-empty-permissions-page',

  data() {
    return {
      titleI18n: 'auth.emptyPermissions.title',
      messageI18n: 'auth.emptyPermissions.message',
      butttons: {
        android: {
          textSupI18n: 'common.downloadButton.android.availableOn',
          textNameI18n: 'common.downloadButton.android.nameStore',
          icon: 'icon-android-brands',
          url: 'https://play.google.com/store/apps/details?id=com.owqlo.app&hl=es_419',
        },
        ios: {
          textSupI18n: 'common.downloadButton.ios.availableOn',
          textNameI18n: 'common.downloadButton.ios.nameStore',
          icon: 'icon-apple-brands',
          url: 'https://apps.apple.com/es/app/owqlo/id1441823663',
        },
      },
    };
  },

  created() {
    this.doSignout({navigateOnSubmit: false});
  },

  methods: {
    ...mapActions({
      doSignout: 'auth/doSignout',
    }),
  },
};
</script>

<style lang="scss" scoped>
.empty-permissions-page .layout__q-logo {
  width: 800px;
}

.empty-permissions-page {
  &__wrapper {
    background-color: white;
    position: absolute;
    width: 754px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    box-shadow: -10px 10px 20px 0 rgba(30, 30, 30, 0.05);
    padding: 4em 0 3em 3em;
    
    &__content {
      grid-area: content;
      display: grid;
      grid-template-rows: 110px 70px 60px 1fr;
      grid-template-columns: auto auto auto;
      grid-template-areas: 'logo . phone'
                            'title title phone'
                            'description description phone'
                            ' download-buttons  download-buttons phone';
      @include mobile { 
        background-color: white;
        padding: 5%;
        grid-template-rows: 110px 80px 90px auto 100px;
        grid-template-columns: auto;
        grid-template-areas:  
                              'logo '
                              'title '
                              'description '
                              'phone'
                              'download-buttons';
        justify-items: center;
        text-align: center;
      }

      &__logo {
        grid-area: logo;
        align-self: center;

        &__img {
          width: 200px;
        }
      }
      &__title {
        grid-area: title;
        font-size: 2rem;
        color: #333333;

        @include mobile {
          font-size: 2rem;
        }
      }
      &__description {
        grid-area: description;
        font-size: 1.2rem;

         @include mobile {
          padding: 5%;
          align-self: center;
        }
      }
      &__download-buttons {
        grid-area: download-buttons;
        display: grid;
        grid-template-columns: 200px 200px;
        grid-gap: 40px;
        align-items: center;

        @include mobile { 
          grid-template-columns: 150px 150px;
          grid-template-rows: 50px ;
          font-size: 10px;
          grid-gap: 20px;
        }
      }
      &__phone {
        grid-area: phone;
        &__img {
          width: 200px;
          
          @include mobile {
            padding-left: 30px;
          }
        }
      }
    }

    @include mobile {
      align-content: center;
      padding: 0 0 0 0;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
